(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["sisiyuyu-product-trust-stack"] && !Shopify.designMode) return;
  try {
    const trustBlocks = document.querySelectorAll('.sisi-product-trust-block');

  trustBlocks.forEach((trustBlock) => {
    const modal = trustBlock.querySelector('[data-sisi-video-modal]');
    const frame = trustBlock.querySelector('[data-sisi-video-frame]');
    const title = trustBlock.querySelector('[data-sisi-video-title]');
    const caption = trustBlock.querySelector('[data-sisi-video-caption]');
    const closeButton = trustBlock.querySelector('[data-sisi-video-close]');

    if (!modal || !frame) return;

    const toEmbedUrl = (rawUrl) => {
      if (!rawUrl) return '';

      let url;
      try {
        url = new URL(rawUrl, window.location.origin);
      } catch (error) {
        return rawUrl;
      }

      if (url.hostname.includes('youtu.be')) {
        const id = url.pathname.split('/').filter(Boolean)[0];
        return id ? `https://www.youtube.com/embed/${id}` : rawUrl;
      }

      if (url.hostname.includes('youtube.com')) {
        const id = url.searchParams.get('v');
        return id ? `https://www.youtube.com/embed/${id}` : rawUrl;
      }

      if (url.hostname.includes('vimeo.com')) {
        const id = url.pathname.split('/').filter(Boolean).pop();
        return id ? `https://player.vimeo.com/video/${id}` : rawUrl;
      }

      return rawUrl;
    };

    const openModal = (trigger) => {
      const rawUrl = trigger.dataset.videoUrl || '';
      const coverUrl = trigger.dataset.coverUrl || '';
      const embedUrl = toEmbedUrl(rawUrl);
      const modalTitle = trigger.dataset.videoTitle || '';
      const modalCaption = trigger.dataset.videoCaption || '';

      frame.innerHTML = '';

      if (embedUrl) {
        if (/\.(mp4|webm|mov)(\?|#|$)/i.test(embedUrl)) {
          const video = document.createElement('video');
          video.src = embedUrl;
          video.controls = true;
          video.autoplay = true;
          video.playsInline = true;
          frame.appendChild(video);
        } else {
          const iframe = document.createElement('iframe');
          iframe.src = embedUrl;
          iframe.title = modalTitle || 'Product video';
          iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
          iframe.allowFullscreen = true;
          frame.appendChild(iframe);
        }
      } else {
        const image = document.createElement('img');
        image.src = coverUrl;
        image.alt = modalTitle || 'Product video preview';
        frame.appendChild(image);
      }

      if (title) {
        title.textContent = modalTitle;
        title.hidden = !modalTitle;
      }

      if (caption) {
        caption.textContent = modalCaption;
        caption.hidden = !modalCaption;
      }

      modal.hidden = false;
      document.documentElement.classList.add('sisi-video-modal-open');
      closeButton?.focus();
    };

    const closeModal = () => {
      modal.hidden = true;
      frame.innerHTML = '';
      document.documentElement.classList.remove('sisi-video-modal-open');
    };

    trustBlock.querySelectorAll('[data-sisi-video-trigger]').forEach((trigger) => {
      trigger.addEventListener('click', () => openModal(trigger));
    });

    closeButton?.addEventListener('click', closeModal);
    modal.addEventListener('click', (event) => {
      if (event.target === modal) closeModal();
    });
    document.addEventListener('keydown', (event) => {
      if (!modal.hidden && event.key === 'Escape') closeModal();
    });
  });
  } catch(e) { console.error(e); }
})();

})();
